
const digest = 'f6e47f9c32ad27cb78dc326e813222d3d41a838e4b9e95496601a4b0369ca9c5';
const classes = {"wrapper":"_wrapper_13ur9_1","row":"_row_13ur9_8","bar":"_bar_13ur9_19","shimmer":"_shimmer_13ur9_1","avatar":"_avatar_13ur9_27 _bar_13ur9_19","stack":"_stack_13ur9_35","w30":"_w30_13ur9_42","w50":"_w50_13ur9_46","w70":"_w70_13ur9_50","action":"_action_13ur9_54 _bar_13ur9_19","wrapperCompact":"_wrapperCompact_13ur9_77"};
const css = `._wrapper_13ur9_1 {
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 1px 0;
}

._row_13ur9_8 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 18px 24px;
  border: 1px solid #eaedf3;
  border-top: 0;
  background-color: #fff;
}

._bar_13ur9_19 {
  background: linear-gradient(90deg, #eef0f4 25%, #f6f7f9 37%, #eef0f4 63%);
  background-size: 400% 100%;
  border-radius: 4px;
  height: 12px;
  animation: _shimmer_13ur9_1 1.4s ease infinite;
}

._avatar_13ur9_27 {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  flex-shrink: 0;
}

._stack_13ur9_35 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-grow: 1;
}

._w30_13ur9_42 {
  width: 30%;
}

._w50_13ur9_46 {
  width: 50%;
}

._w70_13ur9_50 {
  width: 70%;
}

._action_13ur9_54 {
  width: 120px;
  height: 28px;
  border-radius: 14px;
  flex-shrink: 0;
}

@keyframes _shimmer_13ur9_1 {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
@media (prefers-reduced-motion: reduce) {
  ._bar_13ur9_19,
  ._avatar_13ur9_27,
  ._action_13ur9_54 {
    animation: none;
  }
}
._wrapperCompact_13ur9_77 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 16px;
  min-width: 180px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  